module.exports = __webpack_public_path__ + "img/managed-services.d6cb6d27.jpg";